import React from "react";
import { Form } from "react-bootstrap";

const EmployeeScheduleRulesCard = ({ state }) => {
  const currentItem = state.currentItem ?? {};

  const update = (propertyName, value) => {
    const normalized = value === "" ? null : Number(value);
    state.setCurrentItem(current => ({ ...current, [propertyName]: normalized }));
    state.setItemChanged(!state.itemChanged);
    state.setCurrentFormState(current => ({ ...current, formSaveButtonDisabled: false }));
  };

  const valueOf = propertyName => currentItem[propertyName] ?? "";

  return (
    <div className="card">
      <div className="card-header">Zasady planowania czasu pracy</div>
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-3">
            <Form.Label>Minimalnie godzin / tydzień</Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="0.25"
              value={valueOf("scheduleMinWeeklyHours")}
              placeholder="domyślnie bez minimum"
              onChange={event => update("scheduleMinWeeklyHours", event.target.value)}
            />
          </div>
          <div className="col-md-3">
            <Form.Label>Maksymalnie godzin / tydzień</Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="0.25"
              value={valueOf("scheduleMaxWeeklyHours")}
              placeholder="domyślnie bez limitu"
              onChange={event => update("scheduleMaxWeeklyHours", event.target.value)}
            />
          </div>
          <div className="col-md-3">
            <Form.Label>Wymagane dni wolne / tydzień</Form.Label>
            <Form.Control
              type="number"
              min="0"
              max="7"
              step="1"
              value={valueOf("scheduleRequiredDaysOffPerWeek")}
              placeholder="ustawienie globalne"
              onChange={event => update("scheduleRequiredDaysOffPerWeek", event.target.value)}
            />
          </div>
          <div className="col-md-3">
            <Form.Label>Maks. kolejnych dni pracy</Form.Label>
            <Form.Control
              type="number"
              min="1"
              max="31"
              step="1"
              value={valueOf("scheduleMaxConsecutiveWorkDays")}
              placeholder="ustawienie globalne"
              onChange={event => update("scheduleMaxConsecutiveWorkDays", event.target.value)}
            />
          </div>
        </div>
        <div className="form-text mt-2">
          Puste pola korzystają z ustawień globalnych. Limity są sprawdzane zarówno przy ręcznym przypisaniu, jak i przy generowaniu grafiku.
        </div>
      </div>
    </div>
  );
};

export default EmployeeScheduleRulesCard;
